export default (
  callback: IntersectionObserverCallback,
  options?: IntersectionObserverInit,
) => new IntersectionObserver(callback, options || {});
